module.exports = __webpack_public_path__ + "img/pdf.a9d176f0.png";